import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTrash = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.33333 8.33331C8.79358 8.33331 9.16667 8.7064 9.16667 9.16665V13.3333C9.16667 13.7936 8.79358 14.1666 8.33333 14.1666C7.8731 14.1666 7.5 13.7936 7.5 13.3333V9.16665C7.5 8.7064 7.8731 8.33331 8.33333 8.33331Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M11.6666 8.33331C12.1269 8.33331 12.5 8.7064 12.5 9.16665V13.3333C12.5 13.7936 12.1269 14.1666 11.6666 14.1666C11.2064 14.1666 10.8333 13.7936 10.8333 13.3333V9.16665C10.8333 8.7064 11.2064 8.33331 11.6666 8.33331Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.33332 1.66666C6.95261 1.66666 5.83332 2.78595 5.83332 4.16666H3.33332H2.49999C2.03976 4.16666 1.66666 4.53976 1.66666 4.99999C1.66666 5.46022 2.03976 5.83332 2.49999 5.83332H3.33332V15.8333C3.33332 17.2141 4.45261 18.3333 5.83332 18.3333H14.1667C15.5474 18.3333 16.6667 17.2141 16.6667 15.8333V5.83332H17.5C17.9602 5.83332 18.3333 5.46022 18.3333 4.99999C18.3333 4.53976 17.9602 4.16666 17.5 4.16666H16.6667H14.1667C14.1667 2.78595 13.0474 1.66666 11.6667 1.66666H8.33332ZM12.5 4.16666C12.5 3.70642 12.1269 3.33332 11.6667 3.33332H8.33332C7.87309 3.33332 7.49999 3.70642 7.49999 4.16666H12.5ZM5.83332 5.83332H4.99999V15.8333C4.99999 16.2936 5.37309 16.6667 5.83332 16.6667H14.1667C14.6269 16.6667 15 16.2936 15 15.8333V5.83332H14.1667H5.83332Z",
			fill: "currentColor"
		})
	]
});
export default SvgTrash;
